import React, { useState, useEffect } from "react";
import { getAllJobs } from "./../../../../api";
import { Link } from "react-router-dom";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import Button from "@mui/material/Button";
import { Container, Box, Typography, Stack, Paper } from "@mui/material";
import Image from "./../../images/cardsbg.svg";
import "./styles.css";
import Media from "react-media";

const styles = {
  Container2: {
    backgroundImage: `url(${Image})`,
    backgroundBlendMode: "multipy",
    height: "max-content",
    padding: "5% 0px",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    backgroundPosition: "center center",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
};

const bull = (
  <Box component="span" sx={{ display: "inline-block", mx: "2px", transform: "scale(0.8)" }}>
    •
  </Box>
);

const card = (val, i) => (
  <React.Fragment>
    <CardContent
      display="flex"
      flexDirection="column"
      justifyContent="space-evenly"
      className="card_content"
    >
      <p
        className={`cards__category ${
          i % 2 === 0 ? "cards__category--even" : "cards__category--odd"
        }`}
      >
        {val.category}
      </p>
      <div className="cards__thumbnail_container">
        <img className="cards__thumbnail" src={val.thumbnail} alt="thumbnail" />
      </div>
      <Typography
        sx={{ color: "hsla(228, 100%, 21%, 1)", fontWeight: "bold", marginTop: "10px" }}
        variant="h5"
        component="div"
      >
        {val.Name}
      </Typography>
      <Typography variant="body2">{val.company_name}idshsahgshgsioh</Typography>
      <Typography className="card_content_place">{val.location}</Typography>
    </CardContent>
    <CardActions className="card_actions">
      <button className="cards__button">
        <Link to="/Jobs">Know More</Link>
      </button>
    </CardActions>
  </React.Fragment>
);

const Cards = () => {
  const [allJobsData, setAllJobsData] = useState([]);

  useEffect(async () => {
    const response = await getAllJobs(1, 3);
    setAllJobsData(
      response.data.jobs.length > 3 ? response.data.jobs.slice(0, 3) : response.data.jobs
    );
    console.log(response.data.jobs);
  }, []);
  return (
    <>
      <Container style={styles.Container2} maxWidth="100%">
        <Stack
          direction="column"
          display="flex"
          justifyContent="space-evenly"
          sx={{ minWidth: "100%", flexWrap: "wrap" }}
        >
          <Typography
            variant="h4"
            color="hsl(228, 96%, 21%)"
            fontWeight="700"
            sx={{ margin: "auto", borderBottom: "0.5rem solid #FDC500" }}
          >
            Latest Jobs
          </Typography>
          <Stack
            direction="row"
            display="flex"
            justifyContent="space-evenly"
            sx={{
              margin: "2rem",
              flexWrap: "wrap",
              gridColumnGap: "2rem",
              borderRadius: "25px",
              background: "#fff",
            }}
          >
            {allJobsData.length === 0 ? (
              <h2 className="jobs__no">No jobs to show</h2>
            ) : (
              allJobsData.map((val, i) => {
                return (
                  <Paper
                    sx={{
                      maxWidth: "370px",
                      width: "100%",
                      borderRadius: "1rem",
                      display: "flex",
                      flexDirection: "column",
                      padding: "1rem 1.5rem 0.3rem",
                      margin: "1rem",
                      boxSizing: "border-box",
                      overflow: "hidden",
                      position: "relative",
                      height: "fit-content",
                      background: "#e5e5e5",
                    }}
                  >
                    {card(val, i)}
                  </Paper>
                );
              })
            )}
          </Stack>
          <Button
            sx={{
              border: "3px solid hsla(228, 100%, 21%, 1)",
              width: "max-content",
              margin: "auto",
              backgroundColor: "white",
              boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
            }}
          >
            <Link className="browse__link" to="/Jobs">
              BROWSE ALL JOBS
            </Link>
          </Button>
        </Stack>
      </Container>
    </>
  );
};

export default Cards;
